export default __webpack_public_path__ + "static/media/grilabs.1d64cd7d.svg";